module.exports = __webpack_public_path__ + "img/remove-tag.189615ac.svg";